/** Shared by Team Analytics and Talent (pool) Analytics. */
const dictionary = {
  "en": {
    "tabs": {
      "keyAnalytics": "Key analytics",
      "behaviours": "Behaviours",
      "workStyles": "Work styles",
      "motivations": "Values & Motivation",
      "adept": "Adept-15",
      "salesStrengths": "Sales strengths",
      "teamStrengths": "Team strengths"
    },
    "download": {
      "all": "All",
      "behaviours": "Behaviours",
      "workStyles": "Work Styles",
      "motivations": "Value & Motivation",
      "salesStrengths": "Sales Strength",
      "teamStrengths": "Team Strength",
      "adept": "Adept",
      "pdf": "PDF",
      "excel": "Excel"
    },
    "types": {
      "competency": "Competency",
      "attitude": "Attitude",
      "competencyAndAttitude": "Competency & Attitude",
      "competence": "Competence"
    },
    "allTeams": "All teams",
    "allPositions": "All Positions",
    "selectTeams": "Select teams",
    "selectPositions": "Select positions",
    "generateReport": "Generate Report",
    "showChart": "Show Chart",
    "individuals": "Individual's",
    "adeptTraits": "Adept-15 Traits",
    "groups": {
      "all": "All",
      "interactive": "Interactive",
      "operational": "Operational",
      "intellectual": "Intellectual",
      "emotional": "Emotional",
      "objectives": "Objectives",
      "relationships": "Relationships",
      "environment": "Environment"
    },
    "strengthType": "Strength Type",
    "selectSalesStrengthType": "Select sales strength type",
    "selectColumn": "Select column",
    "highestMetrics": "Highest metrics",
    "lowestMetrics": "Lowest metrics",
    "highestValue": "Highest value ",
    "radarChart": "Radar Chart",
    "attitudeSuffix": "(Attitude)",
    "competencySuffix": "(Competency)",
    "strengthTypeColumn": "Strength Type",
    "generatingReport": "Generating Report",
    "generatingReportOf": "Generating Report {count} of {total}",
    "table": {
      "workStylesFile": "WorkStyles",
      "workStylesReport": "Work Style Preferences Report",
      "behavioursFile": "Behaviours",
      "behavioursReport": "Behaviours Report",
      "motivationsFile": "Motivations",
      "motivationsReport": "Motivations Report",
      "teamStrengthsFile": "TeamStrengths",
      "teamStrengthsReport": "Team Strengths Report",
      "adeptFile": "Adept",
      "adeptReport": "Adept Report",
      "isAboveAverage": "is above Average",
      "isBelowAverage": "is below Average",
      "howToReadChart": "How to read this Chart?",
      "aboveAverageRange": "7-9 Above Average",
      "belowAverageRange": "1-3 Below Average",
      "howToGetInsights": "How to get insights and recommendations?",
      "clickStrengths": "Click on each of the strengths in the graph."
    },
    "chartTitles": {
      "averageMetric": "Average {metric}",
      "groupAIndividualMetric": "Group A Individual {metric}",
      "individualMetric": "Individual {metric}",
      "groupBIndividualMetric": "Group B Individual {metric}",
      "metricHighlights": "{metric} Highlights",
      "groupAMetric": "Group A {metric}",
      "groupBMetric": "Group B {metric}",
      "valuesMotivations": "Values & Motivation",
      "valuesMotivation": "Values & Motivation",
      "selectedGroupAverage": "Selected Group average",
      "groupAAverage": "Group A average",
      "groupBAverage": "Group B average"
    }
  },
  "de": {
    "tabs": {
      "keyAnalytics": "Team Analysen",
      "behaviours": "Verhaltensstile",
      "workStyles": "Arbeitsstile",
      "motivations": "Werte & Motivation",
      "adept": "Adept-15",
      "salesStrengths": "Verkaufsstärken",
      "teamStrengths": "Teamstärken"
    },
    "download": {
      "all": "Alle",
      "behaviours": "Verhaltensstile",
      "workStyles": "Arbeitsstile",
      "motivations": "Werte & Motivation",
      "salesStrengths": "Verkaufsstärke",
      "teamStrengths": "Teamstärke",
      "adept": "Adept-15",
      "pdf": "PDF",
      "excel": "Excel"
    },
    "types": {
      "competency": "Kompetenz",
      "attitude": "Haltung",
      "competencyAndAttitude": "Kompetenz & Haltung",
      "competence": "Kompetenz"
    },
    "allTeams": "Alle Teams",
    "allPositions": "Alle Positionen",
    "selectTeams": "Teams auswählen",
    "selectPositions": "Positionen auswählen",
    "generateReport": "Bericht erstellen",
    "showChart": "Diagramm anzeigen",
    "individuals": "Individuelle",
    "adeptTraits": "Adept-15-Merkmale",
    "groups": {
      "all": "Alle",
      "interactive": "Interaktiv",
      "operational": "Operativ",
      "intellectual": "Intellektuell",
      "emotional": "Emotional",
      "objectives": "Ziele",
      "relationships": "Beziehungen",
      "environment": "Umfeld"
    },
    "strengthType": "Stärkentyp",
    "selectSalesStrengthType": "Verkaufsstärkentyp auswählen",
    "selectColumn": "Spalte auswählen",
    "highestMetrics": "Höchste Kennzahlen",
    "lowestMetrics": "Niedrigste Kennzahlen",
    "highestValue": "Höchster Wert ",
    "radarChart": "Netzdiagramm",
    "attitudeSuffix": "(Haltung)",
    "competencySuffix": "(Kompetenz)",
    "strengthTypeColumn": "Stärkentyp",
    "generatingReport": "Bericht wird erstellt",
    "generatingReportOf": "Bericht {count} von {total} wird erstellt",
    "table": {
      "workStylesFile": "Arbeitsstile",
      "workStylesReport": "Bericht zu Arbeitsstilpräferenzen",
      "behavioursFile": "Verhaltensweisen",
      "behavioursReport": "Verhaltensbericht",
      "motivationsFile": "Motivationen",
      "motivationsReport": "Motivationsbericht",
      "teamStrengthsFile": "Teamstaerken",
      "teamStrengthsReport": "Teamstärkenbericht",
      "adeptFile": "Adept",
      "adeptReport": "Adept-Bericht",
      "isAboveAverage": "liegt über dem Durchschnitt",
      "isBelowAverage": "liegt unter dem Durchschnitt",
      "howToReadChart": "Wie ist dieses Diagramm zu lesen?",
      "aboveAverageRange": "7–9 überdurchschnittlich",
      "belowAverageRange": "1–3 unterdurchschnittlich",
      "howToGetInsights": "Wie erhalte ich Erkenntnisse und Empfehlungen?",
      "clickStrengths": "Klicken Sie im Diagramm auf die einzelnen Stärken."
    },
    "chartTitles": {
      "averageMetric": "Durchschnitt {metric}",
      "groupAIndividualMetric": "Gruppe A individuell {metric}",
      "individualMetric": "Individuell {metric}",
      "groupBIndividualMetric": "Gruppe B individuell {metric}",
      "metricHighlights": "{metric} Highlights",
      "groupAMetric": "Gruppe A {metric}",
      "groupBMetric": "Gruppe B {metric}",
      "valuesMotivations": "Werte & Motivationen",
      "valuesMotivation": "Werte & Motivation",
      "selectedGroupAverage": "Durchschnitt der ausgewählten Gruppe",
      "groupAAverage": "Durchschnitt Gruppe A",
      "groupBAverage": "Durchschnitt Gruppe B"
    }
  },
  "fi": {
    "tabs": {
      "keyAnalytics": "Keskeiset analyysit",
      "behaviours": "Käyttäytyminen",
      "workStyles": "Työskentelytyylit",
      "motivations": "Arvot ja motivaatio",
      "adept": "Adept-15",
      "salesStrengths": "Myyntivahvuudet",
      "teamStrengths": "Tiimivahvuudet"
    },
    "download": {
      "all": "Kaikki",
      "behaviours": "Käyttäytyminen",
      "workStyles": "Työskentelytyylit",
      "motivations": "Arvot ja motivaatio",
      "salesStrengths": "Myyntivahvuudet",
      "teamStrengths": "Tiimivahvuudet",
      "adept": "Adept-15",
      "pdf": "PDF",
      "excel": "Excel"
    },
    "types": {
      "competency": "Osaaminen",
      "attitude": "Asenne",
      "competencyAndAttitude": "Osaaminen ja asenne",
      "competence": "Osaaminen"
    },
    "allTeams": "Kaikki tiimit",
    "allPositions": "Kaikki tehtävät",
    "selectTeams": "Valitse tiimit",
    "selectPositions": "Valitse tehtävät",
    "generateReport": "Luo raportti",
    "showChart": "Näytä kaavio",
    "individuals": "Yksilön",
    "adeptTraits": "Adept-15-piirteet",
    "groups": {
      "all": "Kaikki",
      "interactive": "Vuorovaikutuksellinen",
      "operational": "Toiminnallinen",
      "intellectual": "Älyllinen",
      "emotional": "Tunne-elämä",
      "objectives": "Tavoitteet",
      "relationships": "Suhteet",
      "environment": "Ympäristö"
    },
    "strengthType": "Vahvuustyyppi",
    "selectSalesStrengthType": "Valitse myyntivahvuustyyppi",
    "selectColumn": "Valitse sarake",
    "highestMetrics": "Korkeimmat tulokset",
    "lowestMetrics": "Matalimmat tulokset",
    "highestValue": "Korkein arvo",
    "radarChart": "Tutkakaavio",
    "attitudeSuffix": "(Asenne)",
    "competencySuffix": "(Osaaminen)",
    "strengthTypeColumn": "Vahvuustyyppi",
    "generatingReport": "Luodaan raporttia",
    "generatingReportOf": "Luodaan raporttia {count} / {total}",
    "table": {
      "workStylesFile": "Työskentelytyylit",
      "workStylesReport": "Työskentelytyyliraportti",
      "behavioursFile": "Käyttäytyminen",
      "behavioursReport": "Käyttäytymisraportti",
      "motivationsFile": "Motivaatiotekijät",
      "motivationsReport": "Motivaatiotekijäraportti",
      "teamStrengthsFile": "Tiimivahvuudet",
      "teamStrengthsReport": "Tiimivahvuusraportti",
      "adeptFile": "Adept-15",
      "adeptReport": "Adept-raportti",
      "isAboveAverage": "on keskimääräistä korkeampi",
      "isBelowAverage": "on keskimääräistä matalampi",
      "howToReadChart": "Miten kaaviota luetaan?",
      "aboveAverageRange": "7-9 keskiarvon yläpuolella",
      "belowAverageRange": "1-3 keskiarvon alapuolella",
      "howToGetInsights": "Miten saat oivalluksia ja suosituksia?",
      "clickStrengths": "Napsauta kaavion vahvuuksia yksi kerrallaan."
    },
    "chartTitles": {
      "averageMetric": "Keskiarvo: {metric}",
      "groupAIndividualMetric": "Ryhmä A, yksilötaso: {metric}",
      "individualMetric": "Yksilötaso: {metric}",
      "groupBIndividualMetric": "Ryhmä B, yksilötaso: {metric}",
      "metricHighlights": "Kohokohdat: {metric}",
      "groupAMetric": "Ryhmä A: {metric}",
      "groupBMetric": "Ryhmä B: {metric}",
      "valuesMotivations": "Arvot ja motivaatio",
      "valuesMotivation": "Arvot ja motivaatio",
      "selectedGroupAverage": "Valitun ryhmän keskiarvo",
      "groupAAverage": "Ryhmän A keskiarvo",
      "groupBAverage": "Ryhmän B keskiarvo"
    }
  }
};

export default dictionary;
